import React from 'react';
import { RestartAltOutlined } from '@mui/icons-material';
import moment from 'moment';
import Tooltip from '@src/components/Tooltip';
import CommonButton from '@src/new-components/Button';
import DropdownCustom from '@src/new-components/Dropdown';
import { SORT_TYPES } from '@src/constants/voiceCloning';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import DateRangePickerCustom from '@src/new-components/DateRangePicker';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { StyledFilter } from './index.style';

const Filter = ({
  search,
  selectedDate,
  handleDateRangeChange,
  sortType,
  handleSortTypeChange,
  handleResetFilter,
}) => {
  const { t } = useTranslation();

  const presetOptions = [
    {
      label: t('lastNumberDays', { number: 7 }),
      getRange: () => {
        const end = moment().subtract(1, 'day').endOf('day');
        const start = moment().subtract(7, 'days').startOf('day');
        return [start.toDate(), end.toDate()];
      },
      key: 'last7Days',
    },
    {
      label: t('thisMonth'),
      getRange: () => {
        const start = moment().startOf('month');
        const end = moment().endOf('month');
        return [start.toDate(), end.toDate()];
      },
      key: 'thisMonth',
    },
    {
      label: t('lastMonth'),
      getRange: () => {
        const start = moment().subtract(1, 'month').startOf('month');
        const end = moment().subtract(1, 'month').endOf('month');
        return [start.toDate(), end.toDate()];
      },
      key: 'lastMonth',
    },
    {
      label: t('allTimeV2'),
      getRange: () => [null, null],
      key: 'allTime',
    },
  ];

  return (
    <StyledFilter>
      <div className="metrics-container">
        <Typography variant="body-20-bold" color={COLOR.darkGray}>
          {t('metrics')}
        </Typography>
        {selectedDate?.value[1] || selectedDate.type === 'allTime' ? (
          <Typography
            variant="body-14-regular"
            color={COLOR.descriptionUpload}
            style={{
              height: '28px',
            }}
            className="last-updated"
          >
            {t('lastUpdated', {
              date: moment()
                .endOf('day')
                .subtract(1, 'day')
                .format('DD/MM/YYYY'),
            })}
          </Typography>
        ) : (
          <div style={{ height: '28px' }} />
        )}
      </div>
      <div className="filter-container">
        <DateRangePickerCustom
          selectedDate={selectedDate}
          onChange={handleDateRangeChange}
          options={presetOptions}
          format="DD/MM/YYYY"
          placeholder={t('allTimeV2')}
          shouldDisableDate={(date) => moment(date).isAfter(moment(), 'day')}
        />
        <DropdownCustom
          variant="earnings-management"
          options={Object.values(SORT_TYPES).map((type) => ({
            label: t(type),
            value: type,
          }))}
          startIcon={
            <SortRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
          }
          onChange={handleSortTypeChange}
          title={
            <Typography variant="body-14-medium" color={COLOR.darkBlue}>
              {t(sortType)}
            </Typography>
          }
          value={sortType}
        />
        <Tooltip arrow title={t('reset')} placement="top">
          <div>
            <CommonButton
              customStyle={{
                width: '40px',
                height: '40px',
                minWidth: '40px',
              }}
              variant="outlineSmall"
              disabled={
                !search &&
                !selectedDate?.value[0] &&
                !selectedDate?.value[1] &&
                sortType === SORT_TYPES.RevenueDown
              }
              onClick={handleResetFilter}
            >
              <RestartAltOutlined
                sx={{ fontSize: '24px', color: COLOR.navyBlue }}
              />
            </CommonButton>
          </div>
        </Tooltip>
      </div>
    </StyledFilter>
  );
};

export default Filter;
